import { observable, action, makeObservable } from 'mobx';

class AriaStore {
	isModalOpen = false;

	constructor() {
		makeObservable(this, {
			isModalOpen: observable,
			setIsModalOpen: action
		});
	}

	setIsModalOpen(isOpen: boolean) {
		this.isModalOpen = isOpen;
	}
}

export default AriaStore;
